<template>
  <div class="inline-flex">
    <BaseButton info small @click="openModal"> Details </BaseButton>

    <Portal to="app-dialog">
      <OrderItemDetailsModal v-if="open" :order-item-id="orderItemId" @close="closeModal" />
    </Portal>
  </div>
</template>

<script>
import OrderItemDetailsModal from './order-item-details-modal.vue';

export default {
  components: { OrderItemDetailsModal },
  props: {
    orderItemId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    setOpen(open) {
      this.open = open;
    },
    openModal() {
      this.setOpen(true);
    },
    closeModal() {
      this.setOpen(false);
    },
  },
};
</script>
